import http from '@/utils/http';
const call=async(action,data)=>{const response=await http({url:'/api/admin/v1/contractProjectOrderBatch/'+action,data,method:'post'});if(response?.code!==0)throw Error(response?.message||response?.msg||'项目批量预检失败');return response.data;};
export default {create:data=>call('create',data),preview:data=>call('preview',data),copyDraft:data=>call('copyDraft',data)};
